import React, { Component } from 'react';
import { withRouter } from '../../helpers/withRouter';
import ClientDashboardContent from '../blocks/client/ClientDashboardContent';
import MainNav from '../blocks/navigation/MainNav';
import Alert from '../elements/Alert';
import type {
  Project, ProjectStatistics, Router, User,
} from '../../types';

type Props = {
  currentUser: User,
  navigate: object,
  projectStatistics: ProjectStatistics,
  onGetProjectMonthStatistic: Function,
  onGetProjectMonthReportStatistic: Function,
  projects: Array<Project>,
  router: Router,
};

class ClientDashboard extends Component<Props> {
  render(): React.ReactNode {
    const {
      onGetProjectMonthStatistic, currentUser,
      projectStatistics, projects, router, onGetProjectMonthReportStatistic,
    } = this.props;

    return (
      <div className="client-dashboard-view container-view">
        <MainNav
          currentUser={currentUser}
          navigate={router.navigate}
        />
        {projects && projects.length > 0
          ? (
            <ClientDashboardContent
              projectStatistics={projectStatistics}
              projects={projects}
              onGetProjectMonthStatistic={onGetProjectMonthStatistic}
              onGetProjectMonthReportStatistic={onGetProjectMonthReportStatistic}
              preSelectedProjectId={router?.params.id}
              currentUser={currentUser}
              router={router}
            />
          ) : (
            <div className="container mt-4">
              <Alert display message="You have not been added to any projects yet." />
            </div>
          )
        }
      </div>
    );
  }
}

const ConnectedClientDashboard = withRouter(ClientDashboard as any);

export default ConnectedClientDashboard;
